import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface Field {
  name: string
  initialValue?: any
}
interface IQueryParams {
  fields: Field[]
}

const useQueryParams = ({ fields }: IQueryParams) => {
  const location = useLocation()
  const navigate = useNavigate()

  const searchParams = useMemo(() => new URLSearchParams(location.search), [])

  let defaultValues: {
    [key: string]: any
  } = {}

  fields.forEach(({ name, initialValue }: Field) => {
    const param = searchParams.get(name)
    if (param === 'true' || param === 'false') {
      defaultValues[name] = param === 'true' ? true : false
    } else {
      defaultValues[name] = param || initialValue
    }
  })

  const setParams = (data: { [key: string]: any }) => {
    Object.keys(data).forEach((key: string) => {
      if (data[key] === '') {
        searchParams.delete(key)
      } else if (data[key] !== defaultValues[key]) {
        searchParams.set(key, String(data[key]))
      }
    })

    navigate(`?${searchParams.toString()}`)
  }

  return { defaultValues, setParams }
}

export default useQueryParams
